export const TOGGLE_LOADING = 'admission/note/TOGGLE_LOADING'
export const TOGGLE_SUCCESS = 'admission/note/TOGGLE_SUCCESS'
export const GET_NOTE = 'admission/note/GET_NOTE'
export const GET_HISTORY = 'admission/note/GET_HISTORY'
export const SET_NOTES = 'admission/note/SET_NOTES'
export const SET_HISTORY = 'admission/note/SET_HISTORY'
export const CREATE_NOTE = 'admission/note/CREATE_NOTE'
export const CREATE_REPLY_NOTE = 'admission/note/CREATE_REPLY_NOTE'
export const SET_CREATED_NOTE = 'admission/note/SET_CREATED_NOTE'
export const SET_CREATE_REPLY_NOTE = 'admission/note/SET_CREATE_REPLY_NOTE'
export const EDIT_NOTE = 'admission/note/EDIT_NOTE'
export const EDIT_REPLY = 'admission/note/EDIT_REPLY'
export const SET_EDITED_NOTE = 'admission/note/SET_EDITED_NOTE'
export const DELETE_NOTE = 'admission/note/DELETE_NOTE'
export const SET_DELETED_NOTE = 'admission/note/SET_DELETED_NOTE'
export const SET_PERMISSIONS = 'admission/note/SET_PERMISSIONS'
export const CLEAR_HISTORY = 'admission/note/CLEAR_HISTORY'
export const PAGINATE_NOTE = 'admission/note/PAGINATE_NOTE'
export const PAGINATE_REPLY = 'admission/note/PAGINATE_REPLY'
export const SET_PAGINATE_REPLY = 'admission/note/SET_PAGINATE_REPLY'
export const PAGINATE_HISTORY = 'admission/note/PAGINATE_HISTORY'
export const SORT_NOTE = 'admission/note/SORT_NOTE'
